<template>
  <div class="history_page">
    <div class="history_page_inner">
      <div class="custom_container">
        <div class="operations_history_outer">
          <div class="block_title">
            <h3>{{ $t("activity_history") }}
              <div class="close_page">
                <a @click.prevent="MainPageActive" href="">
                  <svg height="15px" viewBox="0 0 311 311.07733" width="15px" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#fff"
                      d="m16.035156 311.078125c-4.097656 0-8.195312-1.558594-11.308594-4.695313-6.25-6.25-6.25-16.382812 0-22.632812l279.0625-279.0625c6.25-6.25 16.382813-6.25 22.632813 0s6.25 16.382812 0 22.636719l-279.058594 279.058593c-3.136719 3.117188-7.234375 4.695313-11.328125 4.695313zm0 0" />
                    <path fill="#fff"
                      d="m295.117188 311.078125c-4.097657 0-8.191407-1.558594-11.308594-4.695313l-279.082032-279.058593c-6.25-6.253907-6.25-16.386719 0-22.636719s16.382813-6.25 22.636719 0l279.058594 279.0625c6.25 6.25 6.25 16.382812 0 22.632812-3.136719 3.117188-7.230469 4.695313-11.304687 4.695313zm0 0" />
                  </svg>
                </a>
              </div>
            </h3>
          </div>
          <div id="history_page_inner" @scroll="onScroll" class="operations_history_table">

            <div v-if="isMobile === false" class="table_desktop">
              <div class="table_head_row">
                <div class="table_head_col h1">{{ $t("start_date") }}</div>
                <div class="table_head_col h1">{{ $t("finish_date") }}</div>
                <div class="table_head_col h2">{{ $t("station_name") }}</div>
                <div class="table_head_col h3">{{ $t("consumed_energy") }}</div>
                <div class="table_head_col h4">{{ $t("sum") }}</div>
              </div>
              <transition name="fade">
                <div v-if="loading === false" class="table_body">
                  <!-- eslint-disable-next-line -->
                  <div v-for="(item, index) in paginatedData" :key="index" @click="show_graph_modal(item)"
                    class="table_body_row">
                    <div class="table_body_col b1">
                      {{ subtractThreeHours(item.Startdt, 3) }}
                    </div>
                    <div v-if="item.Stopdt != null" class="table_body_col b1">
                      {{ subtractThreeHours(item.Stopdt, 3) }}
                    </div>
                    <div v-else class="table_body_col b1">

                    </div>
                    <div class="table_body_col b2">
                      {{ item.Location.replace("amp;", "") }}
                    </div>
                    <div class="table_body_col b3">
                      {{ item.Import }} kWh
                    </div>
                    <div class="table_body_col b4">
                      {{ item.Cost }} {{ item.SysCurrencyIso }}
                    </div>
                  </div>
                </div>
              </transition>
              <img v-if="loading === true" src="/images/new_spinner.gif" alt="" class="spinner">
            </div>

            <div v-else class="table_mobile">
              <transition name="fade">
                <div v-if="loading === false" id="table_mobile_container" class="table_mobile_inner">
                  <!-- eslint-disable-next-line -->
                  <div v-for="(item, index) in activityHistory" :key="index" class="table_mobile_item">
                    <div class="item_row">
                      <span>{{ $t("start_date") }}</span><span>
                        {{ subtractThreeHours(item.Startdt, 3) }} <span v-if="item.MinPercent"> - {{ item.MinPercent }}%</span>
                      </span>
                    </div>
                    <hr>
                    <div class="item_row">
                      <span>{{ $t("finish_date") }}</span><span>
                        {{ subtractThreeHours(item.Stopdt, 3) }} <span v-if="item.MaxPercent"> - {{ item.MaxPercent }}%</span>
                      </span>
                    </div>
                    <hr>
                    <div class="item_row">
                      <span>{{ $t("station_name") }}</span><span>{{ item.Location.replace("amp;", "") }}</span>
                    </div>
                    <hr>
                    <div class="item_row">
                      <span>{{ $t("consumed_energy") }}</span><span>{{ item.Import }} kWh</span>
                    </div>
                    <hr>
                    <div class="item_row">
                      <span>{{ $t("sum") }}</span><span>{{ item.Cost }} {{ item.SysCurrencyIso }}</span>
                    </div>
                    <hr v-if="item.IsGraph === 1">
                    <div v-if="item.IsGraph === 1" class="item_row">
                      <span>Max power</span><span>{{ item.maxPow }} kW</span>
                    </div>
                    <hr v-if="item.IsGraph === 1">
                    <div v-if="item.IsGraph === 1" class="item_row">
                      <span>Average power</span><span>{{ item.avgPow }} kW</span>
                    </div>
                    <hr v-if="item.IsGraph === 1 && item.avgCapacity && item.avgCapacity > 10.00">
                    <div v-if="item.IsGraph === 1 && item.avgCapacity && item.avgCapacity > 10.00" class="item_row">
                      <span>Capacity</span><span>{{ item.avgCapacity }} kWh</span>
                    </div>
                    <hr>
                    <div class="btns">
                      <div v-if="item.IsGraph === 1" @click="show_graph_modal(item)" class="chart-btn h-btn">
                        <svg width="64px" height="64px" viewBox="0 -0.5 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5.11413 8.35688C4.75894 8.56999 4.64377 9.03069 4.85688 9.38587C5.06999 9.74106 5.53069 9.85623 5.88587 9.64312L5.11413 8.35688ZM10.5 6L10.95 5.4C10.7061 5.21704 10.3756 5.19999 10.1141 5.35688L10.5 6ZM14.5 9L14.05 9.6C14.3236 9.80522 14.7014 9.79932 14.9685 9.58565L14.5 9ZM19.9685 5.58565C20.292 5.32689 20.3444 4.85493 20.0857 4.53148C19.8269 4.20803 19.3549 4.15559 19.0315 4.41435L19.9685 5.58565ZM17.75 19C17.75 19.4142 18.0858 19.75 18.5 19.75C18.9142 19.75 19.25 19.4142 19.25 19H17.75ZM19.25 11C19.25 10.5858 18.9142 10.25 18.5 10.25C18.0858 10.25 17.75 10.5858 17.75 11H19.25ZM9.75 19C9.75 19.4142 10.0858 19.75 10.5 19.75C10.9142 19.75 11.25 19.4142 11.25 19H9.75ZM11.25 11C11.25 10.5858 10.9142 10.25 10.5 10.25C10.0858 10.25 9.75 10.5858 9.75 11H11.25ZM13.75 19C13.75 19.4142 14.0858 19.75 14.5 19.75C14.9142 19.75 15.25 19.4142 15.25 19H13.75ZM15.25 14C15.25 13.5858 14.9142 13.25 14.5 13.25C14.0858 13.25 13.75 13.5858 13.75 14H15.25ZM5.75 19C5.75 19.4142 6.08579 19.75 6.5 19.75C6.91421 19.75 7.25 19.4142 7.25 19H5.75ZM7.25 14C7.25 13.5858 6.91421 13.25 6.5 13.25C6.08579 13.25 5.75 13.5858 5.75 14H7.25ZM5.88587 9.64312L10.8859 6.64312L10.1141 5.35688L5.11413 8.35688L5.88587 9.64312ZM10.05 6.6L14.05 9.6L14.95 8.4L10.95 5.4L10.05 6.6ZM14.9685 9.58565L19.9685 5.58565L19.0315 4.41435L14.0315 8.41435L14.9685 9.58565ZM19.25 19V11H17.75V19H19.25ZM11.25 19V11H9.75V19H11.25ZM15.25 19V14H13.75V19H15.25ZM7.25 19V14H5.75V19H7.25Z" fill="#000000"></path> </g></svg>
                      </div>
                      <!-- <div class="tax-btn h-btn">
                        <svg fill="#ffffff" height="64px" width="64px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M427.023,0H84.977C71.126,0,59.858,11.268,59.858,25.119v461.762c0,13.851,11.268,25.119,25.119,25.119h265.086 c2.126,0,4.166-0.844,5.668-2.348l94.063-94.063c1.504-1.503,2.348-3.542,2.348-5.668V25.119C452.142,11.268,440.874,0,427.023,0z M358.079,484.63v-57.607c0-5.01,4.076-9.086,9.086-9.086h57.607L358.079,484.63z M436.109,401.904h-68.944 c-13.851,0-25.119,11.268-25.119,25.119v68.944H84.977c-5.01,0-9.086-4.076-9.086-9.086V25.119c0-5.01,4.076-9.086,9.086-9.086 h342.046c5.01,0,9.086,4.076,9.086,9.086V401.904z"></path> </g> </g> <g> <g> <path d="M204.693,68.409h-68.409c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h26.188v77.495 c0,4.427,3.589,8.017,8.017,8.017s8.017-3.589,8.017-8.017V84.443h26.188c4.427,0,8.017-3.589,8.017-8.017 S209.12,68.409,204.693,68.409z"></path> </g> </g> <g> <g> <path d="M289.332,159.634l-23.826-79.418c-2.119-7.062-8.496-11.807-15.869-11.807h-4.378c-7.373,0-13.75,4.745-15.869,11.807 l-23.826,79.418c-1.272,4.241,1.134,8.71,5.375,9.982c4.241,1.275,8.71-1.134,9.982-5.374l3.416-11.39h46.219l3.417,11.389 c1.042,3.473,4.227,5.715,7.676,5.715c0.762,0,1.538-0.11,2.307-0.34C288.198,168.344,290.605,163.875,289.332,159.634z M229.149,136.818l15.598-51.995c0.067-0.224,0.278-0.381,0.512-0.381h4.378c0.234,0,0.445,0.156,0.512,0.381l15.598,51.995 H229.149z"></path> </g> </g> <g> <g> <path d="M373.732,157.34l-26.712-38.158l26.712-38.158c2.539-3.627,1.657-8.626-1.97-11.165c-3.627-2.539-8.626-1.658-11.165,1.97 l-23.362,33.374l-23.362-33.374c-2.539-3.628-7.539-4.51-11.165-1.97c-3.628,2.539-4.51,7.538-1.97,11.165l26.712,38.158 L300.74,157.34c-2.539,3.627-1.657,8.626,1.97,11.165c1.399,0.98,3.003,1.449,4.59,1.449c2.527,0,5.015-1.192,6.574-3.42 l23.362-33.374l23.362,33.374c1.56,2.228,4.047,3.42,6.574,3.42c1.587,0,3.192-0.47,4.59-1.449 C375.389,165.966,376.272,160.967,373.732,157.34z"></path> </g> </g> <g> <g> <path d="M136.284,213.779h-17.102c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017S140.711,213.779,136.284,213.779z"></path> </g> </g> <g> <g> <path d="M136.284,247.983h-17.102c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017S140.711,247.983,136.284,247.983z"></path> </g> </g> <g> <g> <path d="M136.284,282.188h-17.102c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017S140.711,282.188,136.284,282.188z"></path> </g> </g> <g> <g> <path d="M392.818,213.779h-17.102c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017S397.246,213.779,392.818,213.779z"></path> </g> </g> <g> <g> <path d="M392.818,247.983h-17.102c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017S397.246,247.983,392.818,247.983z"></path> </g> </g> <g> <g> <path d="M392.818,282.188h-17.102c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017S397.246,282.188,392.818,282.188z"></path> </g> </g> <g> <g> <path d="M273.102,213.779H170.489c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h102.614 c4.427,0,8.017-3.589,8.017-8.017S277.53,213.779,273.102,213.779z"></path> </g> </g> <g> <g> <path d="M238.898,247.983h-68.409c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h68.409 c4.427,0,8.017-3.589,8.017-8.017S243.325,247.983,238.898,247.983z"></path> </g> </g> <g> <g> <path d="M273.102,282.188H170.489c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h102.614 c4.427,0,8.017-3.589,8.017-8.017S277.53,282.188,273.102,282.188z"></path> </g> </g> <g> <g> <path d="M152.852,387.18v-27.859c5.907,1.936,9.62,5.833,9.62,9.447c0,4.427,3.589,8.017,8.017,8.017s8.017-3.589,8.017-8.017 c0-12.784-10.768-23.198-25.653-25.984v-1.273c0-4.427-3.589-8.017-8.017-8.017s-8.017,3.589-8.017,8.017v1.273 c-14.885,2.786-25.653,13.2-25.653,25.984c0,17.862,14.265,25.369,25.653,29.69v27.859c-5.907-1.936-9.62-5.834-9.62-9.447 c0-4.427-3.589-8.017-8.017-8.017s-8.017,3.589-8.017,8.017c0,12.784,10.768,23.198,25.653,25.984v1.273 c0,4.427,3.589,8.017,8.017,8.017s8.017-3.589,8.017-8.017v-1.273c14.885-2.786,25.653-13.2,25.653-25.984 C178.505,399.007,164.24,391.5,152.852,387.18z M136.818,380.966c-7.992-3.916-9.62-7.337-9.62-12.198 c0-3.614,3.713-7.511,9.62-9.447V380.966z M152.852,426.315V404.67c7.992,3.916,9.62,7.337,9.62,12.198 C162.472,420.482,158.758,424.38,152.852,426.315z"></path> </g> </g> <g> <g> <path d="M264.551,350.597h-59.858c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h59.858 c4.427,0,8.017-3.589,8.017-8.017S268.979,350.597,264.551,350.597z"></path> </g> </g> <g> <g> <path d="M238.898,419.006h-34.205c-4.427,0-8.017,3.589-8.017,8.017c0,4.427,3.589,8.017,8.017,8.017h34.205 c4.427,0,8.017-3.589,8.017-8.017C246.914,422.596,243.325,419.006,238.898,419.006z"></path> </g> </g> <g> <g> <path d="M290.205,419.006h-17.102c-4.427,0-8.017,3.589-8.017,8.017c0,4.427,3.589,8.017,8.017,8.017h17.102 c4.427,0,8.017-3.589,8.017-8.017C298.221,422.596,294.632,419.006,290.205,419.006z"></path> </g> </g> <g> <g> <path d="M315.858,384.802H204.693c-4.427,0-8.017,3.589-8.017,8.017c0,4.427,3.589,8.017,8.017,8.017h111.165 c4.427,0,8.017-3.589,8.017-8.017C323.875,388.391,320.285,384.802,315.858,384.802z"></path> </g> </g> <g> <g> <circle cx="273.102" cy="256" r="8.017"></circle> </g> </g> <g> <g> <circle cx="307.307" cy="256" r="8.017"></circle> </g> </g> <g> <g> <circle cx="341.511" cy="256" r="8.017"></circle> </g> </g> <g> <g> <circle cx="307.307" cy="221.795" r="8.017"></circle> </g> </g> <g> <g> <circle cx="341.511" cy="221.795" r="8.017"></circle> </g> </g> <g> <g> <circle cx="307.307" cy="290.205" r="8.017"></circle> </g> </g> <g> <g> <circle cx="341.511" cy="290.205" r="8.017"></circle> </g> </g> </g></svg>
                      </div> -->
                  </div>
                  </div>
                </div>
              </transition>
              <img v-if="loading === true" src="/images/new_spinner.gif" alt="" class="spinner">
            </div>

          </div>
        </div>
      </div>
      <div v-show="isMobile === false && pageCount > 1" class="pagination">
        <button class="prev" :disabled="pageNumber === 0" @click="prevPage">&lt;</button>
        <span>{{ pageNumber + 1 }} / {{ pageCount }}</span>
        <button class="next" :disabled="pageNumber >= pageCount - 1" @click="nextPage">&gt;</button>
      </div>
      <transition name="fade">
        <div v-if="graph_modal" @click.self="graph_modal = false" class="graph_modal">
          <div class="graph_modal_inner">
            <a @click.prevent="graph_modal = false">
              <svg height="15px" viewBox="0 0 311 311.07733" width="15px" xmlns="http://www.w3.org/2000/svg">
                <path fill="#fff"
                  d="m16.035156 311.078125c-4.097656 0-8.195312-1.558594-11.308594-4.695313-6.25-6.25-6.25-16.382812 0-22.632812l279.0625-279.0625c6.25-6.25 16.382813-6.25 22.632813 0s6.25 16.382812 0 22.636719l-279.058594 279.058593c-3.136719 3.117188-7.234375 4.695313-11.328125 4.695313zm0 0" />
                <path fill="#fff"
                  d="m295.117188 311.078125c-4.097657 0-8.191407-1.558594-11.308594-4.695313l-279.082032-279.058593c-6.25-6.253907-6.25-16.386719 0-22.636719s16.382813-6.25 22.636719 0l279.058594 279.0625c6.25 6.25 6.25 16.382812 0 22.632812-3.136719 3.117188-7.230469 4.695313-11.304687 4.695313zm0 0" />
              </svg>
            </a>
            <BarChart ref="bar" :chartData="chartData" :options="chartOptions" />
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="graph_modal_ac" @click.self="graph_modal_ac = false" class="graph_modal">
          <div class="graph_modal_inner">
            <a @click.prevent="graph_modal_ac = false">
              <svg height="15px" viewBox="0 0 311 311.07733" width="15px" xmlns="http://www.w3.org/2000/svg">
                <path fill="#fff"
                  d="m16.035156 311.078125c-4.097656 0-8.195312-1.558594-11.308594-4.695313-6.25-6.25-6.25-16.382812 0-22.632812l279.0625-279.0625c6.25-6.25 16.382813-6.25 22.632813 0s6.25 16.382812 0 22.636719l-279.058594 279.058593c-3.136719 3.117188-7.234375 4.695313-11.328125 4.695313zm0 0" />
                <path fill="#fff"
                  d="m295.117188 311.078125c-4.097657 0-8.191407-1.558594-11.308594-4.695313l-279.082032-279.058593c-6.25-6.253907-6.25-16.386719 0-22.636719s16.382813-6.25 22.636719 0l279.058594 279.0625c6.25 6.25 6.25 16.382812 0 22.632812-3.136719 3.117188-7.230469 4.695313-11.304687 4.695313zm0 0" />
              </svg>
            </a>
            <BarChart ref="bar" :chartData="chartDataAc" :options="chartOptionsAc" />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import BarChart from './charts/HistoryChart'
import moment from 'moment'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

export default {
  name: "HistoryPage",
  components: {
    BarChart
  },
  data() {
    return {
      blockScroll: false,
      currentPage: 1,
      activityHistory: [],
      pageNumber: 0,
      size: 10,
      loading: false,
      graph_modal: false,
      graph_modal_ac: false,
      chartData: {
        labels: [],
        datasets: [
          // {
          //   data: [],
          //   label: "kW",
          //   borderColor: "#62A321",
          //   pointRadius: 0,
          //   borderWidth: 2,
          //   fill: false
          // },
          {
            label: 'kW',
            data: [],
            borderColor: "blue",
            pointRadius: 0,
            borderWidth: 2,
            yAxisID: 'y',
            backgroundColor: "blue",
          },
          {
            label: 'Percent',
            data: [],
            borderColor: "#62A321",
            pointRadius: 0,
            borderWidth: 2,
            fill: true,
            yAxisID: 'y1',
            backgroundColor: "#62A321",
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        layout: {
          padding: {
            top: 25,
            bottom: 25,
            right: 25,
            left: 25
          }
        },
        scales: {
          x: {
            ticks: {
              maxTicksLimit: 10
            }
          },
          y: {
            grid: {
              display: false
            },
            type: 'linear',
            display: true,
            color: "blue",
            position: 'left',
            ticks: {
              color: 'blue',
              stepSize: 20,
              autoSkip: true,
              maxTicksLimit: 10
            }
          },
          y1: {
            type: 'linear',
            display: true,
            color: "#62A321",
            position: 'right',
            min: 0,
            max: 100,
            ticks: {
              stepSize: 20,
              color: '#62A321',
              autoSkip: true
            }
          },
        }
      },
      chartDataAc: {
        labels: [],
        datasets: [
          {
            label: 'kW',
            data: [],
            borderColor: "blue",
            pointRadius: 0,
            borderWidth: 2,
            yAxisID: 'y',
            backgroundColor: "blue",
          }
        ]
      },
      chartOptionsAc: {
        responsive: true,
        maintainAspectRatio: true,
        layout: {
          padding: {
            top: 25,
            bottom: 25,
            right: 25,
            left: 25
          }
        },
        scales: {
          x: {
            ticks: {
              maxTicksLimit: 10
            }
          },
          y: {
            type: 'linear',
            display: true,
            color: "blue",
            position: 'left',
            ticks: {
              color: 'blue',
              maxTicksLimit: 10
            }
          }
        }
      }
    }
  },
  mounted() {
    let browser = window.navigator.userAgent.substr(-40,)
    let firefox = browser.indexOf('Firefox')
    let mi = browser.indexOf('MiuiBrowser')
    if (firefox >= 0 || mi >= 0) {
      document.querySelector('.history_page_inner').style.background = 'rgba(0, 0, 0, 0.8)'
    }
    this.fetchHistory();
  },
  methods: {
    onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
      let _this = this;
      if(this.$store.getters.getIsMobile && _this.blockScroll === false) {
          if (scrollTop + clientHeight >= scrollHeight - 10) {
          _this.loadMore();
        }
      }
    },
    loadMore() {
      let _this = this
      this.blockScroll = true;
      let historyUrl = process.env.VUE_APP_API_URL + '/app/besp/session/history/?format=json&o_record_per_page=30&o_pageno='+_this.currentPage+'&f_token=' + localStorage.getItem('AuthToken')
      axios({
        url: 'https://voltspot.net/url/cors.php',
        method: 'POST',
        params: {
          url: historyUrl
        }
      })
        .then(resp => {
          if (resp.data.rcode >= 0) {
            _this.currentPage++;
            let noneZeroRecords = resp.data.rdata.Records.filter(item => parseFloat(item.Cost) > 0.01 || parseFloat(item.Import) > 0.01);
            noneZeroRecords.forEach(function (item) {
              if (item.IsGraph == 1) {
              let graphUrl = 'http://api2.voltspot.net/app/besp/session/graph/' + item.Key + '?format=json';

              axios({
                url: 'https://voltspot.net/url/cors.php',
                method: 'POST',
                params: {
                  url: graphUrl
                }
              })
                .then(resp => {
                  if (resp.data.rcode >= 0) {
                    let graph_power = resp.data.rdata.Record.GraphPower;
                    let pows = _this.getTicksMaxAndAvg(graph_power);
                    item.avgCapacity = _this.getAvgCapacity(resp.data.rdata.Record);
                    item.MinPercent = _this.getMinMaxPercents(resp.data.rdata.Record, 0);
                    item.MaxPercent = _this.getMinMaxPercents(resp.data.rdata.Record, 1);
                    item.maxPow = pows.max;
                    item.avgPow = pows.avg;
                    if(pows.max < 1 && pows.avg < 1) {
                      item.IsGraph = 0;
                    }
                  } else {
                    console.log('Ошибка получения списка графиков: ' + resp.data.rtext)
                  }
                })
              } else {
                item.maxPow = 0;
                item.avgPow = 0;
                item.avgCapacity = 0;
                item.MaxPercent = 0;
                item.MinPercent = 0;
              }
              _this.activityHistory.push(item);
            });
            _this.blockScroll = false;
          } else {
            console.log('Ошибка получения списка истории активности: ' + resp.data.rtext)
          }
        });
    },
    throttle(callee, timeout) {
      let timer = null
      return function perform(...args) {
        if (timer) return

        timer = setTimeout(() => {
          callee(...args)

          clearTimeout(timer)
          timer = null
        }, timeout)
      }
    },
    fetchHistory() {
      let _this = this
      this.loading = true
      let historyUrl = process.env.VUE_APP_API_URL + '/app/besp/session/history/?format=json&o_record_per_page=999&f_token=' + localStorage.getItem('AuthToken')
      if(this.$store.getters.getIsMobile) {
        historyUrl = process.env.VUE_APP_API_URL + '/app/besp/session/history/?format=json&o_record_per_page=30&o_pageno='+this.currentPage+'&f_token=' + localStorage.getItem('AuthToken')
      }
      axios({
        url: 'https://voltspot.net/url/cors.php',
        method: 'POST',
        params: {
          url: historyUrl
        }
      })
        .then(resp => {
          if (resp.data.rcode >= 0) {
            _this.setActivityData(resp.data.rdata.Records);
            if(_this.$store.getters.getIsMobile) {
              _this.currentPage++;
            }
          } else {
            console.log('Ошибка получения списка истории активности: ' + resp.data.rtext)
          }
          _this.loading = false
        });
    },
    checkPosition() {
      const height = document.getElementById('history_page_inner').offsetHeight
      const screenHeight = window.innerHeight
      const scrolled = window.scrollY
      const threshold = height - screenHeight / 4
      const position = scrolled + screenHeight

      if (position >= threshold) {
        console.log('height ' + height)
        console.log('screenHeight ' + screenHeight)
        console.log('scrolled ' + scrolled)
        console.log('threshold ' + threshold)
        console.log('position ' + position)
        console.log('---------')
      }
    },
    setActivityData(records) {
      let _this = this;
      let noneZeroRecords = records.filter(item => parseFloat(item.Cost) > 0.01 || parseFloat(item.Import) > 0.01);

      Promise.all(noneZeroRecords.map(async item => {
        if (item.IsGraph == 1) {
          let graphUrl = 'http://api2.voltspot.net/app/besp/session/graph/' + item.Key + '?format=json';
          await axios({
            url: 'https://voltspot.net/url/cors.php',
            method: 'POST',
            params: {
              url: graphUrl
            }
          })
          .then(resp => {
            if (resp.data.rcode >= 0) {
              let graph_power = resp.data.rdata.Record.GraphPower;
              let pows = _this.getTicksMaxAndAvg(graph_power);
              item.avgCapacity = _this.getAvgCapacity(resp.data.rdata.Record);
              item.MaxPercent = _this.getMinMaxPercents(resp.data.rdata.Record, 1);
              item.MinPercent = _this.getMinMaxPercents(resp.data.rdata.Record, 0);
              item.maxPow = pows.max;
              item.avgPow = pows.avg;
              if(pows.max < 1 && pows.avg < 1) {
                item.IsGraph = 0;
              }
            } else {
              console.log('Ошибка получения списка графиков: ' + resp.data.rtext)
            }
          })
        } else {
          item.maxPow = 0;
          item.avgPow = 0;
          item.avgCapacity = 0;
          item.MaxPercent = 0;
          item.MinPercent = 0;
        }
      })).then(() => {
        _this.activityHistory = noneZeroRecords;
      }).catch(error => {
        console.error('Ошибка обработки данных:', error);
      });
    },
    getMinMaxPercents(item, isMax) {
      let graph_percent = item.Percent;
      let percent_labels = Object.values(graph_percent);
      if(!graph_percent || graph_percent.length == 0) {
        return 0
      }
      try {
        return isMax ? Math.max(...percent_labels) : Math.min(...percent_labels)
      } catch {
        return 0
      }
    },
    getTicksMaxAndAvg(ticks) {
      // eslint-disable-next-line no-unused-vars
      const filteredTicks = Object.entries(ticks).filter(([key, value]) => value !== 0);
      if(filteredTicks != '') {
        // eslint-disable-next-line no-unused-vars
        const maxValue = Math.max(...filteredTicks.map(([_, value]) => value));
        // eslint-disable-next-line no-unused-vars
        const avgValue = filteredTicks.reduce((acc, [_, value]) => acc + value, 0) / filteredTicks.length;
        return {
          max: maxValue.toFixed(2),
          avg: avgValue.toFixed(2),
        };
      } else {
        return {
          max: 0,
          avg: 0,
        };
      }
    },
    getAvgCapacity(item) {
      let hasPercent = false;
      if(item.Percent) {
        if(Object.keys(item.Percent).length) {
          hasPercent = true;
        }
      }
      if(hasPercent) {
        const percents = item.Percent;
        let filteredValues = Object.values(percents).filter(value => value > 0);
        if (filteredValues.length > 1) {
            let min = Math.min(...filteredValues);
            let max = Math.max(...filteredValues);
            if(max-min < 10) {
              return 0;
            }
            return (100/(max-min)*item.Import).toFixed(2);
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
    show_graph_modal(item) {
      if (item.IsGraph == 1) {
        let graphUrl = 'http://api2.voltspot.net/app/besp/session/graph/' + item.Key + '?format=json';
        axios({
          url: 'https://voltspot.net/url/cors.php',
          method: 'POST',
          params: {
            url: graphUrl
          }
        })
          .then(resp => {
            if (resp.data.rcode >= 0) {
              const percent = resp.data.rdata.Record.Percent;
              const isAC = Array.isArray(percent) && !percent.length;

              let graph_power = resp.data.rdata.Record.GraphPower;
              let graph_power_trim_zeros = {};
              for (const key of Object.keys(graph_power)) {
                if (graph_power[key] !== 0) {
                  graph_power_trim_zeros[key] = graph_power[key];
                }
              }
              // let power_labels = Object.keys(graph_power);
              // for (let i = 0; i < power_labels.length; i++) {
              //   let date = new Date(parseInt(power_labels[i]));
              //   power_labels[i] = moment.unix(date).subtract(3, 'h').format('HH:mm');
              // }
              // this.chartData.labels = power_labels;
              isAC ? this.chartDataAc.datasets[0].data = Object.values(graph_power_trim_zeros) : this.chartData.datasets[0].data = Object.values(graph_power_trim_zeros);

              if(isAC) {
                let power_labels = Object.keys(graph_power);
                for (let i = 0; i < power_labels.length; i++) {
                  let date = new Date(parseInt(power_labels[i]));
                  power_labels[i] = moment.unix(date).subtract(3, 'h').format('HH:mm');
                }
                this.chartDataAc.labels = power_labels;
              } else {
                let graph_percent = resp.data.rdata.Record.Percent;
                let percent_labels = Object.keys(graph_percent);
                for (let i = 0; i < percent_labels.length; i++) {
                  let date = new Date(parseInt(percent_labels[i]));
                  percent_labels[i] = moment.unix(date).subtract(3, 'h').format('HH:mm');
                }
                this.chartData.labels = percent_labels;
                this.chartData.datasets[1].data = Object.values(graph_percent);
              }

              isAC ? this.graph_modal_ac = true : this.graph_modal = true;
            } else {
              console.log('Ошибка получения списка графиков: ' + resp.data.rtext)
            }
          })
      }
    },
    subtractThreeHours(date, hour = 0) {
      try {
        const d = new Date(date);
        d.setHours(d.getHours() - hour);
        return moment(d).format('DD-MM-YYYY H:mm');
      } catch(e) {
        console.log('Ошибка преобразования даты')
        return 0;
      }
    },
    hide_graph_modal() {
      this.graph_modal = false;
    },
    MainPageActive() {
      this.$store.commit('setMainPage')
    },
    nextPage() {
      this.pageNumber++
    },
    prevPage() {
      this.pageNumber--
    },
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 575
    },
    pageCount() {
      let l = this.activityHistory.length,
        s = this.size
      return Math.ceil(l / s)
    },
    paginatedData() {
      const start = this.pageNumber * this.size
      const end = start + this.size
      return this.activityHistory.slice(start, end)
    }
  },
  created() {
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    window.addEventListener('resize', () => {
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    })
  }
}
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.history_page {

  .history_page_inner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-height: 100vh;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    margin-top: 40px;
    padding-top: 80px;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(1px);
    z-index: 402;

    .graph_modal {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.1);
      z-index: 1005;
      backdrop-filter: blur(1px);
      display: flex;
      justify-content: center;
      align-items: center;

      .graph_modal_inner {
        display: flex;
        background: #fff;
        box-shadow: 0 1px 6px 0 rgb(32 33 36 / 30%) !important;
        border-radius: 5px;
        position: relative;
        max-width: 90%;
        overflow: hidden;

        &>div {
          max-width: 100%;
        }

        a {
          position: absolute;
          top: 10px;
          right: 10px;
          line-height: 1;
          cursor: pointer;

          svg {
            path {
              fill: #000;
            }
          }
        }
      }
    }

    .block_title {
      h3 {
        color: #fff;
        font-size: 2.2rem;
        font-weight: 400;
        line-height: 1;
        display: block;
        margin: 0 0 30px 0;
        position: relative;

        .close_page {
          position: absolute;
          top: 0;
          right: 0;

          a {
            background: transparent;
            font-weight: 400;
            height: 30px;
            width: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 1.8rem;
            border: 1px solid #fff;
            border-radius: 5px;
            text-decoration: none;
            outline: none;
            box-shadow: 1px 1px 8px rgba(255, 255, 255, 0.4);
            transition: all .2s linear;

            &:hover {
              transition: all .2s linear;
              box-shadow: 1px 1px 8px rgba(255, 255, 255, 0.8);
              background: rgba(0, 0, 0, 0.2);
            }
          }
        }
      }
    }

    .pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      width: 100%;

      span {
        font-family: 'Proxima Nova', sans-serif;
        font-size: 1.2rem;
        line-height: 1;
        color: #fff;
        width: 100px;
        height: 28px;
        align-items: center;
        flex-wrap: nowrap;
        display: flex;
        justify-content: center;
        user-select: none;
        text-align: center;
      }

      button {
        outline: none;
        display: flex;
        border: 1px solid #fff;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        font-size: 1.5rem;
        font-weight: 400;
        line-height: 1;
        transition: all .2s linear;
        user-select: none;
        box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);

        &.prev {
          border-bottom-left-radius: 5px;
          border-top-left-radius: 5px;
        }

        &.next {
          border-bottom-right-radius: 5px;
          border-top-right-radius: 5px;
        }

        &:disabled {
          transition: all .2s linear;
          border: 1px solid #fff;
          background: transparent;
        }
      }
    }

    .operations_history_table {

      &::-webkit-scrollbar {
        display: none;
      }

      .table_desktop {
        display: flex;
        width: 100%;
        min-height: 300px;
        flex-direction: column;
        margin-bottom: 30px;
        position: relative;

        .table_head_row {
          display: flex;
          justify-content: space-between;

          .table_head_col {
            user-select: none;
            color: #fff;
            font-size: 0.9rem;
            font-weight: 400;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            &.h1 {
              width: 25%;
              padding-left: 20px;
            }

            &.h2 {
              width: 35%;
            }

            &.h3 {
              width: 25%;
            }

            &.h4 {
              width: 15%;
            }
          }
        }

        .table_body {
          display: flex;
          width: 100%;
          flex-direction: column;
          min-height: 350px;

          .table_body_row {
            display: flex;
            width: 100%;
            justify-content: space-between;
            background: rgba(0, 0, 0, 0.5);
            margin: 3px 0;
            border: 1px solid #000;
            box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);
            cursor: pointer;

            &:first-child {
              border-top-left-radius: 5px;
              border-top-right-radius: 5px;
            }

            &:last-child {
              border-bottom-left-radius: 5px;
              border-bottom-right-radius: 5px;
            }

            .table_body_col {
              user-select: none;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              color: #fff;
              font-size: 0.9rem;
              overflow: hidden;
              font-weight: 400;
              line-height: 1.5;
              white-space: nowrap;

              &.b1 {
                width: 25%;
                padding-left: 20px;
              }

              &.b2 {
                width: 35%;
              }

              &.b3 {
                width: 25%;
              }

              &.b4 {
                width: 15%;
              }
            }
          }
        }

        .spinner {
          z-index: 2;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -25px 0 0 -25px;
          width: 50px;
          height: 50px;

          & .path {
            stroke: hsl(210, 70, 75);
            stroke-linecap: round;
            animation: dash 1.5s ease-in-out infinite;
          }

        }
      }

      .table_mobile {
        display: flex;
        width: 100%;
        position: relative;

        &::-webkit-scrollbar {
          width: 10px;
        }

        &::-webkit-scrollbar-track {
          -webkit-border-radius: 10px;
          border-radius: 10px;
        }

        &::-webkit-scrollbar-thumb {
          -webkit-border-radius: 10px;
          border-radius: 10px;
          background: #fff;
        }

        .table_mobile_inner {
          width: 100%;

          .table_mobile_item {
            font-size: 0.8rem;
            padding: 5px;
            border-radius: 5px;
            display: flex;
            background: rgba(0, 0, 0, 0.6);
            flex-direction: column;
            color: #fff;
            margin-bottom: 10px;

            &:last-child {
              margin-bottom: 0;
            }

          .btns {
            display: flex;
            justify-content: flex-start;
            grid-gap: 20px;
            align-items: center;
            margin: 10px 0;

            .h-btn {
              padding: 5px;
              height: 50px;
              width: 70px;
              overflow: hidden;
              display: flex;
              align-items: center;
              border-radius: 5px;
              justify-content: center;
              background-color: rgba(255,255,255,0.1);
              border: 1px solid rgba(255,255,255,0.2);

              svg {
                height: 40px;
                width: auto;
              }
            }

            .tax-btn.h-btn {
              svg {
                height: 35px;
              }
            }
          }

            .item_row {
              display: flex;

              span {
                font-size: 0.8rem;
              }

              span:first-child {
                width: 40%;
              }

              span:last-child {
                width: 60%;
              }
            }

            hr {
              width: 100%;
              height: 1px;
              border: none;
              background: rgba(255, 255, 255, 0.3);
              margin: 3px 0;
            }
          }
        }

        .spinner {
          z-index: 2;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -25px 0 0 -25px;
          width: 50px;
          height: 50px;

          & .path {
            stroke: hsl(210, 70, 75);
            stroke-linecap: round;
            animation: dash 1.5s ease-in-out infinite;
          }

        }

      }
    }
  }
}

//MEDIA STYLES
@media screen and (max-width: 991px) {
  .history_page {
    .history_page_inner {
      padding-top: 40px;
      padding-bottom: 50px;

      .operations_history_table {
        .table_mobile {
          .table_mobile_inner {
            padding-bottom: 100px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .history_page {
    .history_page_inner {
      overflow: hidden;

      .operations_history_outer {
        .block_title {
          h3 {
            font-size: 1.6rem;
            padding-right: 35px;

            .close_page {
              top: -5px;
            }
          }
        }

        .operations_history_table {
          max-height: 80vh;
          overflow-y: scroll;

          .table_mobile {}
        }
      }
    }
  }
}

@media screen and (max-width: 330px) {
  .history_page {
    .history_page_inner {
      .operations_history_outer {
        .operations_history_table {
          .table_mobile {
            margin-bottom: 20px;
            min-height: 200px;
            max-height: 300px;
            overflow: scroll;

            .table_mobile_inner {
              .item_row {
                span {
                  font-size: 0.8rem;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
